const body = document.body;

window.addEventListener("scroll", () => {
  document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}`);
});

const openModal = () => {
  const scrollY = document.documentElement.style.getPropertyValue("--scroll-y");

  body.style.position = "fixed";
  body.style.top = `-${scrollY}px`;
  body.style.left = "0px";
  body.style.right = "0px";
};

const closeModal = () => {
  const scrollY = body.style.top;

  body.style.position = "";
  body.style.top = "";
  body.style.left = "";
  body.style.right = "";

  window.scrollTo(0, parseInt(scrollY || "0") * -1);
};

export { openModal, closeModal };
